import dayjs from 'dayjs';

// dayjs <-> stored-string helpers for the shared MUI pickers. Kept out of the
// component file so date-pickers UI stays a components-only module (react-refresh).

export const toDayjs = (v) => (v ? dayjs(v) : null);
export const fromDayjsISO = (d) => (d && d.isValid() ? d.toISOString() : '');

// "HH:mm" <-> dayjs (date part is arbitrary; only the time is used)
export const timeToDayjs = (hhmm) => (hhmm ? dayjs(`2000-01-01T${hhmm}`) : null);
export const dayjsToTime = (d) => (d && d.isValid() ? d.format('HH:mm') : '');
